import firestore from '../firestore'

function defaultComponent () {
  return {
    code: {
      css: '',
      html: `<q-card style="width: 200px">
  <q-card-title>
    {{dataTitle}}
  </q-card-title>
  <q-card-seperator/>
  <q-card-main>
    {{body}}
  </q-card-main>
  <q-card-actions>
    <q-btn flat class="" icon="help" @click="addFun"/>
  </q-card-actions>
</q-card>`,
      js: `return new SubmindVueComponent({
  data: function () {
    return {
      dataTitle: 'Test Card'
    }
  },
  computed: {
    body: function () { return $tc.getSubmatch(1) }
  },
  methods: {
    addFun: function () {
      this.dataTitle += ' :)'
    }
  }
})`,
      md: '\\[example\\|(.*?)\\]',
      desc: `This is my card content

[example|Here's my card content]

Underneath`,
      userData: {},
      scripts: []
    },
    name: 'Example Component',
    description: '',
    enabled: false,
    sourceComponentId: null,
    createdAt: new Date(),
    updatedAt: new Date()
  }
}

function sanitiseComponent (unsanitisedComponent) {
  return {
    code: {
      css: (unsanitisedComponent.code || {}).css || '',
      html: (unsanitisedComponent.code || {}).html || '',
      js: (unsanitisedComponent.code || {}).js || '',
      md: (unsanitisedComponent.code || {}).md || '',
      userData: (unsanitisedComponent.code || {}).userData || '',
      desc: (unsanitisedComponent.code || {}).desc || '',
      scripts: (unsanitisedComponent.code || {}).scriptDefs || []
    },
    name: unsanitisedComponent.name || 'Unnamed Component',
    description: unsanitisedComponent.description || '',
    enabled: unsanitisedComponent.enabled || false,
    sourceComponentId: unsanitisedComponent.sourceComponentId || null,
    publishedId: unsanitisedComponent.publishedId || null,
    updatedAt: unsanitisedComponent.updatedAt || new Date(),
    createdAt: unsanitisedComponent.createdAt || null
  }
}

export const addComponent = ({ state, dispatch }, component) => {
  let sanitised = {}
  if (component == null) {
    sanitised = defaultComponent()
  } else {
    sanitised = sanitiseComponent(component)
    if ('publisher' in component) sanitised.publisher = component.publisher
  }
  let ref = firestore.componentsColRef.doc()
  return ref.set(sanitised).then(() => {
    return ref.id
  })
}

export const updateComponent = ({ state, commit }, component) => {
  let sanatised = sanitiseComponent(component)
  // console.log('update component')
  // console.log(sanatised.code.desc)
  // console.log(state.components[component.id].code.desc)
  return firestore.componentsColRef.doc(component.id).set(sanatised)
}

export const updateComponentEnabled = ({ state, commit }, component) => {
  let sanitised = { enabled: component.enabled || false }
  return firestore.componentsColRef.doc(component.id).set(sanitised, { merge: true })
}

export const deleteComponentWithId = ({ rootState, getters, commit, dispatch }, componentId) => {
  return firestore.componentsColRef.doc(componentId).delete()
}
